/**
 * @generated SignedSource<<1eedef198360ffed0d3ea00ccde1e704>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleHeadlineHeaderFeaturesContent" | "articleSeoArticle" | "articleShareWidgetArticle" | "bookmarkHeaderFeaturesContent" | "commentHeaderFeaturesArticle" | "contentShareWidgetContent" | "entityLinkHeaderFeaturesArticle" | "helpersCheckIsStyleArticle" | "helpersRosettaArticleContextArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseCurrentArticlePrebidConfigArticle" | "hooksUsePageTargetingArticle" | "onboardingNewsletterSubscriptionArticle" | "shareHeaderFeaturesContent">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "009305aa3253367e59dde3d10834e90f";

export default node;
